import React from 'react';
import PropTypes from 'prop-types';
import I10n from '../features/i10n';
import { front_base_url, LICENSE_MODELS, possible_starter_selections } from '../constants';
import SavedConfigurationCard from './application-cards/saved-configuration-card';
import { appConfiguration } from '../utils/app-starter';
import { convertDate } from '../utils/date';

class SavedConfigurationItem extends React.Component {

  static propTypes = {
    id: PropTypes.string,
    configuration: PropTypes.object,
    onConfigurationRestore: PropTypes.func,
    onExport: PropTypes.func,
    onAddToMyProducts: PropTypes.func,
    onAddToList: PropTypes.func,
    onDuplicate: PropTypes.func,
    onDelete: PropTypes.func,
    onSendMail: PropTypes.func,
    active: PropTypes.bool,
    isWorkspaceAvailable: PropTypes.bool,
  };

  onRename = (newName) => {
    this.props.onRename(this.props.configuration, newName);
    this.setState({ isEditingName: false });
  }

  cancelRename = () => {
    this.setState({ isEditingName: false });
  }

  computeConfigurationRange = (config) => {
    if (possible_starter_selections.SOFTWARE_LICENCE === config.configurationType) {
      return I10n.get(`category.${config.softwareSelection}.name`, 'data');
    }

    return I10n.getOrDefault(`ranges.${config.headModuleRange}`, config.headModuleRange, 'data');
  }

  computeStarterType = (config) => {
    let result = '';

    if (possible_starter_selections.SOFTWARE_LICENCE === config.configurationType) {
      result = I10n.get('screen.start_configuration_screen.create.software_licence');
    } else {
      if (possible_starter_selections.PLC_IO === config.starterType) {
        result = I10n.get('screen.start_configuration_screen.plc_io');
      }

      if (possible_starter_selections.PAC === config.starterType) {
        result = I10n.get('screen.start_configuration_screen.pac_io');
      }

      if (possible_starter_selections.EDGE === config.starterType) {
        result = I10n.get('screen.start_configuration_screen.edge_io');
      }
    }

    return result;
  }

  computeWorkspaceActions = () => {
    return [{
      key: 'restore',
      type: 'flat',
      icon: 'list-bullets',
      action: () => {
        this.props.onConfigurationRestore(this.props.configuration.id);
      }
    }, {
      key: 'add_to_project',
      type: 'full',
      icon: 'plus-small',
      size: 30,
      action: () => {
        this.props.onAddToMyProducts(this.props.configuration);
      }
    }];
  }

  computeDropdownAction = () => {

    const {unifiedCheckoutAvailable, isWorkspaceAvailable, launchFromWorkspace } = this.props;
    const isSubscriptionMode = this.props.configuration.licenseModel === LICENSE_MODELS.SUBSCRIPTION;

    const actions = [
      {
        key: 'export',
        icon: 'page-arrow-left',
        label: I10n.get('menu_export'),
        action: () => {
          this.props.onExport(this.props.configuration);
        }
      }
    ];

    if (!isSubscriptionMode) {
      let key, icon, label;

      if (unifiedCheckoutAvailable) {
        key = 'add_to_my_cart';
        icon = 'shopping-cart';
        label = I10n.get('saved_configuration.export.add_cart');
      } else if (isWorkspaceAvailable || launchFromWorkspace) {
        key = 'add_to_my_project';
        icon = 'plus-circle';
        label = I10n.get('saved_configuration.export.my_project');
      } else {
        key = 'add_to_my_products';
        icon = 'plus-circle';
        label = I10n.get('saved_configuration.export.my_product');
      }

      actions.push({
        key: key,
        icon: icon,
        label: label,
        action: () => {
          this.props.onAddToMyProducts(this.props.configuration);
        }
      });

      if (unifiedCheckoutAvailable) {
        actions.push({
          key: 'add_to_list',
          icon: 'list-bullet-square-plus',
          label: I10n.get('saved_configuration.export.add_to_my_list'),
          action: () => {
            this.props.onAddToList(this.props.configuration);
          }
        });
      }
    }
    actions.push(
      {
        key: 'delete',
        icon: 'trash-can',
        label: I10n.get('menu_delete'),
        action: () => {
          this.props.onDelete(this.props.configuration.id);
        }
      }
    );


    return actions;
  }

  computeIconAction = () => {
    const actions = [];

    if (window.self === window.top && appConfiguration.locale !== 'zh-CN') {
      actions.push({
        key: 'shared',
        icon: 'circles-three-connected',
        hint: I10n.get('share_menu'),
        action: () => {
          this.props.onSendMail(this.props.configuration);
        }
      });
    }

    actions.push({
      key: 'copy',
      icon: 'pages-double',
      hint: I10n.get('menu_duplicate'),
      action: () => {
        this.props.onDuplicate(this.props.configuration.id);
      }
    });

    return actions;
  }

  render = () => {
    const config = this.props.configuration;
    return (
      <>
        <SavedConfigurationCard
          id={this.props.id}
          onConfigurationRestore={() => {
            return this.props.onConfigurationRestore(config.id);
          }}
          onRename={this.onRename}
          flagURL={`${front_base_url}/flags/${this.props.configuration.country}.svg`}
          country={this.props.configuration.country}
          computeConfigurationRange={() => {
            return this.computeConfigurationRange(config);
          }}
          computeStarterType={() => {
            return this.computeStarterType(config);
          }}
          labelRenaming={I10n.get(`menu_rename`)}
          primaryColor={this.props.primaryColor}
          secondaryColor={this.props.secondaryColor}
          iconActions={this.computeIconAction()}
          dropdownActions={this.computeDropdownAction()}
          workspaceActions={this.computeWorkspaceActions()}
          countryWarningLabel={I10n.getAndReplace('screen.start_configuration_screen.country_hint', this.props.configuration.country)}
          configurationName={config.name}
          launchFromWorkspace={this.props.launchFromWorkspace}
          isWorkspaceAvailable={this.props.isWorkspaceAvailable}
          dateLabel={convertDate(config.date)}
          active={this.props.active}
        />
      </>
    );
  }
}

export default SavedConfigurationItem;
